/* Cova — scroll reveal.
   IntersectionObserver only; no dependencies. Bails out entirely when the
   visitor prefers reduced motion, and when the API is unavailable everything
   is simply left visible (the CSS default is the revealed state under
   .no-cova-motion). */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    root.classList.add('no-cova-motion');
    return;
  }
  root.classList.add('cova-motion');

  function init() {
    var targets = document.querySelectorAll('[data-cova-reveal]');
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Mega nav (desktop) ---------- */
(function () {
  var nav = document.querySelector('.cova-meganav');
  if (!nav) return;
  var items = nav.querySelectorAll('.cova-meganav__item.has-panel');
  var closeTimer = null;
  function open(item) {
    items.forEach(function (i) { if (i !== item) close(i); });
    item.classList.add('is-open');
    item.querySelector('.cova-meganav__link').setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('cova-meganav-open');
  }
  function close(item) {
    item.classList.remove('is-open');
    item.querySelector('.cova-meganav__link').setAttribute('aria-expanded', 'false');
    if (!nav.querySelector('.cova-meganav__item.is-open')) document.documentElement.classList.remove('cova-meganav-open');
  }
  items.forEach(function (item) {
    var link = item.querySelector('.cova-meganav__link');
    item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(item); });
    item.addEventListener('mouseleave', function () { closeTimer = setTimeout(function () { close(item); }, 140); });
    link.addEventListener('focus', function () { open(item); });
    // Keyboard: Enter/Space toggles; Escape closes
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(item); link.blur(); }
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close(item);
    });
    // Touch/pen: first tap opens, second tap follows the link
    link.addEventListener('click', function (e) {
      var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;
      if (coarse && !item.classList.contains('is-open')) { e.preventDefault(); open(item); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') items.forEach(close);
  });
})();

/* ---------- Shop the look hotspots ---------- */
(function () {
  document.querySelectorAll('.cova-stl').forEach(function (root) {
    var spots = root.querySelectorAll('[data-stl-spot]');
    var cards = root.querySelectorAll('[data-stl-card]');
    var rows  = root.querySelectorAll('[data-stl-row]');
    function set(n) {
      spots.forEach(function (s) { var on = s.dataset.stlSpot === n; s.classList.toggle('is-active', on); s.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.stlCard === n); });
      rows.forEach(function (r)  { r.classList.toggle('is-active', r.dataset.stlRow === n); });
    }
    spots.forEach(function (s) {
      s.addEventListener('click', function () { set(s.classList.contains('is-active') ? null : s.dataset.stlSpot); });
      s.addEventListener('mouseenter', function () { set(s.dataset.stlSpot); });
    });
    rows.forEach(function (r) {
      r.addEventListener('mouseenter', function () { set(r.dataset.stlRow); });
    });
    root.addEventListener('mouseleave', function () { set(null); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) set(null); });
  });
})();

/* ---------- Staggered word reveal for big headlines ---------- */
(function () {
  if (!document.documentElement.classList.contains('cova-motion')) return;
  var targets = document.querySelectorAll('.cova-cine__copy h1, .cova-statement__inner h2, .cova-newin__title');
  targets.forEach(function (el) {
    if (el.dataset.covaSplit) return;
    el.dataset.covaSplit = '1';
    // Wrap each word (keeping inline <em>) in a span so it can animate in.
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    var i = 0;
    textNodes.forEach(function (node) {
      var words = node.textContent.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      words.forEach(function (w) {
        if (!w.trim()) { frag.appendChild(document.createTextNode(w)); return; }
        var s = document.createElement('span');
        s.className = 'cova-w';
        s.style.transitionDelay = (i++ * 55) + 'ms';
        s.textContent = w;
        frag.appendChild(s);
      });
      node.parentNode.replaceChild(frag, node);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
      });
    }, { threshold: 0.2 });
    io.observe(el);
  });
})();
